import { sagas as slotsCalendarSagas } from 'framework/modules/slotManagement/pages/LiveTimeSlotView/store';
import { sagas as slotsTemplateEditSagas } from 'framework/modules/slotManagement/pages/SlotsTemplatesEdit/redux';
import slotsBulkBlockingSagas from 'framework/modules/slotManagement/pages/BulkBlockingSlots/store/sagas';

export default [...slotsCalendarSagas, ...slotsTemplateEditSagas, ...slotsBulkBlockingSagas];
